// chatbot.service.ts
import { Injectable, Inject, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ChatbotService {
    private renderer: Renderer2;
    private botScriptId = 'gr-ai-bot';


    constructor(
        @Inject(DOCUMENT) private document: Document,
        private rendererFactory: RendererFactory2
    ) {
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }

    /**
     * Add chatbot script dynamically
     * @param botId The bot's data-ai ID
     */
    addChatbot(botId: string): void {
        // return;
        // Prevent duplicate script loading
        if (this.document.getElementById(this.botScriptId)) {
            console.log('Chatbot script already added.');
            return;
        }

        const script = this.renderer.createElement('script');

        if (environment.production) {
            script.type = 'text/javascript';
            script.async = true;
            script.src = 'https://chatbot.gravitasai.com/assets/widget.js';
            script.id = this.botScriptId;
            script.setAttribute('data-ai', 'f989510d-7e1f-4b8a-9fb6-cf922b495e5e');
        } else {
            script.type = 'text/javascript';
            script.async = true;
            script.src = 'https://chatbot.gravitasai.com/assets/widget.js';
            script.id = this.botScriptId;
            script.setAttribute('data-ai', '16d13f18-54d9-4b89-a11e-84e058931105');
        }

        console.log('Chatbot script added.');

        setTimeout(() => {
            this.renderer.appendChild(this.document.body, script);
        }, 500); // Delay to ensure proper loading
    }

    /**
     * Remove chatbot script
     */
    removeChatbot(): void {
        // 1️⃣ Remove main script
        const script = this.document.getElementById(this.botScriptId);
        if (script) {
            this.renderer.removeChild(this.document.body, script);
            console.log('✅ Chatbot script removed.');
        } else {
            console.log('ℹ️ Chatbot script not found.');
        }

        // 2️⃣ Remove any injected elements (iframe + containers)
        setTimeout(() => {
            // Explicitly remove iframe
            const iframes = this.document.querySelectorAll('iframe[src*="demo-bot.gravitasai.com"]');
            iframes.forEach(iframe => {
                const parent = iframe.parentElement;
                if (parent && parent.id === 'bot-frame-container') {
                    // Remove parent wrapper if exists
                    if (parent.parentNode) {
                        parent.parentNode.removeChild(parent);
                        console.log('🧹 Removed bot-frame-container with iframe');
                    }
                } else {
                    // Remove iframe alone
                    if (iframe.parentNode) {
                        iframe.parentNode.removeChild(iframe);
                        console.log('🧹 Removed chatbot iframe');
                    }
                }
            });

            // 3️⃣ Extra cleanup — remove any leftover containers or overlays
            const extraSelectors = [
                '#bot-frame-container',
                'div[id*="gravitas"]',
                'div[class*="chatbot"]',
                'div[class*="ai-widget"]'
            ];
            extraSelectors.forEach(selector => {
                const elements = this.document.querySelectorAll(selector);
                elements.forEach(el => {
                    if (el && el.parentNode) {
                        el.parentNode.removeChild(el);
                        console.log(`🧹 Removed element: ${selector}`);
                    }
                });
            });

            console.log('✅ Chatbot completely removed.');
        }, 500); // small delay to ensure iframe injected before cleanup
    }

}
